import { Component } from "react";
import ServerError from "@/pages/ServerError";

// Catches unexpected render errors anywhere below it and shows the branded 500 page.
export class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Unhandled UI error:", error, info);
  }

  reset = () => {
    this.setState({ hasError: false });
  };

  render() {
    if (this.state.hasError) return <ServerError onRetry={this.reset} />;
    return this.props.children;
  }
}
